<template>
  <div class="drawer">
    <div class="drawer-container">
      <div class="drawer-content">
        <el-form class="box" label-width="60px">
          <fieldset class="mgb15">
            <legend>{{ $t("text.baseInfo") }}</legend>
            <el-row>
              <el-col :span="8">
                <el-form-item :label="$t('text.name')">{{
                  phaseTemplate.name
                }}</el-form-item>
              </el-col>
            </el-row>
          </fieldset>

          <fieldset class="mgb15">
            <legend>
              {{ $t("menu.phases") }}&nbsp;&nbsp;
              <i class="el-icon-circle-plus green" @click="add" />
            </legend>

            <vxe-table
              :data="items"
              row-id="id"
              ref="recordsTable"
              class="recordsTable"
              size="mini"
              resizable
              round
              border
              highlight-hover-row
              auto-resize
              :scroll-y="{ enabled: false }"
            >
              <vxe-table-column width="60px">
                <template v-slot="{ row, rowIndex }">
                  <i
                    v-if="rowIndex != 0"
                    class="el-icon-top mgr10"
                    @click="swapSequence(row, rowIndex, 'up')"
                  ></i>
                  <i
                    v-if="rowIndex + 1 != items.length"
                    class="el-icon-bottom"
                    @click="swapSequence(row, rowIndex, 'down')"
                  ></i>
                </template>
              </vxe-table-column>
              <vxe-table-column
                field="sequence"
                :title="$t('text.sequence')"
                width="100px"
              />
              <vxe-table-column field="phaseName" :title="$t('menu.phases')" />
              <vxe-table-column
                field="phaseHour"
                :title="$t('phaseTemplate.phaseHour')"
              >
                <template v-slot="{ row }">{{ row.phaseHour }}小时</template>
              </vxe-table-column>
              <vxe-table-column
                field="period"
                :title="$t('phaseTemplate.period')"
              >
                <template v-slot="{ row }">{{ row.period }}天</template>
              </vxe-table-column>
              <vxe-table-column
                field="inspect"
                :title="$t('phaseTemplate.inspect')"
                width="80px"
              >
                <template v-slot="{ row }">{{
                  $t("boolean." + row.inspect)
                }}</template>
              </vxe-table-column>
              <vxe-table-column
                field="print"
                :title="$t('action.print')"
                width="80px"
              >
                <template v-slot="{ row }">{{
                  $t("boolean." + row.print)
                }}</template>
              </vxe-table-column>
              <vxe-table-column :title="$t('text.action')" width="100">
                <template v-slot="{ row }">
                  <el-button type="text" size="mini" @click="editRow(row)">{{
                    $t("text.edit")
                  }}</el-button>
                  <el-button type="text" size="mini" @click="deleteRow(row)">{{
                    $t("text.delete")
                  }}</el-button>
                </template>
              </vxe-table-column>
            </vxe-table>
          </fieldset>
        </el-form>
      </div>
    </div>

    <el-dialog
      :append-to-body="true"
      :title="$t('text.create')"
      :close-on-click-modal="false"
      :visible.sync="addDF"
      width="30%"
    >
      <el-form ref="addObjForm" :model="addObj" label-width="110px">
        <el-form-item
          :label="$t('menu.phases')"
          :prop="'phaseId'"
          :rules="[
            {
              required: true,
              message: $t('rules.required', [$t('menu.phases')]),
              trigger: 'blur',
            },
          ]"
        >
          <el-select size="small" v-model="addObj.phaseId" filterable clearable>
            <el-option
              v-for="phase in phasesFilter"
              :key="phase.id"
              :label="phase.name"
              :value="phase.id"
            />
          </el-select>
        </el-form-item>
        <el-form-item
          :label="$t('phaseTemplate.phaseHour')"
          :prop="'phaseHour'"
          :rules="[
            {
              required: true,
              message: $t('rules.required', [$t('phaseTemplate.phaseHour')]),
              trigger: 'blur',
            },
          ]"
        >
          <el-input size="small" v-model.trim="addObj.phaseHour" />
        </el-form-item>
        <el-form-item
          :label="$t('phaseTemplate.period')"
          :prop="'period'"
          :rules="[
            {
              required: true,
              message: $t('rules.required', [$t('phaseTemplate.period')]),
              trigger: 'blur',
            },
          ]"
        >
          <el-input size="small" v-model.trim="addObj.period" />
        </el-form-item>
        <el-form-item :label="$t('phaseTemplate.inspect')" :prop="'inspect'">
          <el-checkbox size="small" v-model="addObj.inspect" />
        </el-form-item>
        <el-form-item :label="$t('action.print')" :prop="'print'">
          <el-checkbox size="small" v-model="addObj.print" />
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button
          type="primary"
          plain
          :loading="addDoing"
          size="small"
          @click="addSubmit"
          >{{ $t("text.submit") }}</el-button
        >
        <el-button size="small" @click="addDF = false">{{
          $t("text.close")
        }}</el-button>
      </div>
    </el-dialog>
    <!-- 编辑 -->
    <el-dialog
      :append-to-body="true"
      :title="$t('text.edit')"
      :close-on-click-modal="false"
      :visible.sync="editDF"
      width="30%"
    >
      <el-form ref="editObjForm" :model="editObj" label-width="110px">
        <el-form-item
          :label="$t('text.sequence')"
          :prop="'sequence'"
          :rules="[
            {
              required: true,
              message: $t('rules.required', [$t('text.sequence')]),
              trigger: 'blur',
            },
          ]"
        >
          <el-input
            size="small"
            v-model.trim="editObj.sequence"
            :placeholder="$t('text.sequence')"
          />
        </el-form-item>
        <el-form-item
          :label="$t('phaseTemplate.phaseHour')"
          :prop="'phaseHour'"
          :rules="[
            {
              required: true,
              message: $t('rules.required', [$t('phaseTemplate.phaseHour')]),
              trigger: 'blur',
            },
          ]"
        >
          <el-input size="small" v-model.trim="editObj.phaseHour" />
        </el-form-item>
        <el-form-item
          :label="$t('phaseTemplate.period')"
          :prop="'period'"
          :rules="[
            {
              required: true,
              message: $t('rules.required', [$t('phaseTemplate.period')]),
              trigger: 'blur',
            },
          ]"
        >
          <el-input size="small" v-model.trim="editObj.period" />
        </el-form-item>
        <el-form-item :label="$t('phaseTemplate.inspect')" :prop="'inspect'">
          <el-checkbox size="small" v-model="editObj.inspect" />
        </el-form-item>
        <el-form-item :label="$t('action.print')" :prop="'print'">
          <el-checkbox size="small" v-model="editObj.print" />
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button
          type="primary"
          plain
          :loading="editDoing"
          size="small"
          @click="editSubmit"
          >{{ $t("text.submit") }}</el-button
        >
        <el-button size="small" @click="editDF = false">{{
          $t("text.close")
        }}</el-button>
      </div>
    </el-dialog>
  </div>
</template>
<script>
import { page } from "@/utils/mixins.js";
import Util from "@/utils/index.js";
import PhaseTemplate from "@/api/phaseTemplate.js";
import Phase from "@/api/phase.js";
export default {
  props: {
    id: Number,
  },
  mixins: [page],
  data() {
    return {
      phaseTemplate: {
        name: null,
      },
      items: [],
      // 新增
      phasesFilter: [],
      addDF: false,
      addObj: {
        phaseTemplateId: null,
        phaseId: null,
        phaseName: null,
        phaseHour: null,
        period: null,
        inspect: false,
        print: false,
      },
      addDoing: false,

      // 编辑
      editDF: false,
      row: null,
      editObj: {
        sequence: null,
        phaseId: null,
        phaseName: null,
        phaseHour: null,
        period: null,
        inspect: null,
        print: null,
      },
      editDoing: false,
    };
  },
  created() {
    const self = this;
    self.loadingStart();
    PhaseTemplate.findById(self.id).then(function (res) {
      if (res.data.code === 200) {
        self.phaseTemplate = res.data.entity;
      } else {
        self.sysError();
      }
      self.loadingEnd();
      self.getItems();
    });
  },
  methods: {
    swapSequence(row, rowIndex, type) {
      const self = this;
      const obj = {
        swapId: row.id,
        swapId2:
          type == "up"
            ? self.items[rowIndex - 1].id
            : self.items[rowIndex + 1].id,
      };
      PhaseTemplate.swapSequence(self.phaseTemplate.id, obj).then(function (
        res
      ) {
        if (res.status == 200) {
          self.getItems();
        } else {
          self.sysError();
        }
      });
    },
    //
    deleteRow(row) {
      const self = this;
      PhaseTemplate.deleteItem(self.phaseTemplate.id, row.id).then(function (
        res
      ) {
        if (res.status === 200) {
          self.$message({
            message: self.$t("prompt.delSuccess"),
            type: "success",
          });
          self.getItems();
        } else {
          self.sysError();
        }
      });
    },
    // 编辑
    editRow(row) {
      const self = this;
      self.row = row;
      self.editObj.sequence = row.sequence;
      self.editObj.phaseId = row.phaseId;
      self.editObj.phaseName = row.phaseName;
      self.editObj.phaseHour = row.phaseHour;
      self.editObj.period = row.period;
      self.editObj.inspect = row.inspect;
      self.editObj.print = row.print;
      self.editDoing = false;
      self.editDF = true;
    },
    editSubmit() {
      const self = this;
      if (!Util.regexQuantity(self.editObj.phaseHour)) {
        self.$message({
          message: self.$t("rules.regex", [self.$t("phaseTemplate.phaseHour")]),
          type: "warning",
        });
        return;
      }
      if (!Util.regexQuantity(self.editObj.period)) {
        self.$message({
          message: self.$t("rules.regex", [self.$t("phaseTemplate.period")]),
          type: "warning",
        });
        return;
      }
      self.$refs.editObjForm.validate((valid) => {
        if (valid) {
          self.editDoing = true;
          PhaseTemplate.updateItem(
            self.phaseTemplate.id,
            self.row.id,
            self.editObj
          ).then(function (res) {
            self.editDoing = false;
            self.editDF = false;
            if (res.status === 200) {
              self.$message({
                message: self.$t("prompt.editSuccess"),
                type: "success",
              });
              self.getItems();
            } else {
              self.sysError();
            }
          });
        } else {
          return false;
        }
      });
    },
    // 新增
    add() {
      const self = this;
      self.phasesFilter = [];
      self.addObj.phaseId = null;
      self.addObj.phaseTemplateId = self.phaseTemplate.id;
      self.addObj.phaseHour = null;
      self.addObj.period = null;
      self.addObj.inspect = false;
      self.addObj.print = false;
      Phase.findByTenantId().then(function (res) {
        if (res.status === 200) {
          const phases = res.data;
          if (phases.length !== 0) {
            self.phasesFilter = phases.filter(
              (p) => self.items.find((item) => item.phaseId == p.id) == null
            );
          }
        } else {
          self.sysError();
        }
        self.addDF = true;
      });
    },
    addSubmit() {
      const self = this;
      if (!Util.regexQuantity(self.addObj.phaseHour)) {
        self.$message({
          message: self.$t("rules.regex", [self.$t("phaseTemplate.phaseHour")]),
          type: "warning",
        });
        return;
      }
      if (!Util.regexQuantity(self.addObj.period)) {
        self.$message({
          message: self.$t("rules.regex", [self.$t("phaseTemplate.period")]),
          type: "warning",
        });
        return;
      }
      self.$refs.addObjForm.validate((valid) => {
        if (valid) {
          self.addDoing = true;
          PhaseTemplate.createItem(self.phaseTemplate.id, [self.addObj]).then(
            function (res) {
              self.addDoing = false;
              self.addDF = false;
              if (res.status === 200) {
                self.$message({
                  message: self.$t("prompt.addSuccess"),
                  type: "success",
                });
                self.getItems();
              } else {
                self.sysError();
              }
            }
          );
        } else {
          return false;
        }
      });
    },
    getItems() {
      const self = this;
      PhaseTemplate.findItems(self.id).then(function (res) {
        if (res.status === 200) {
          self.items = res.data;
        } else {
          self.sysError();
        }
      });
    },
  },
};
</script>